import * as types from './types';
import { extractPreferencesFromAccessInfo } from 'Common/Security/SecurityHelpers';

const INITIAL_STATE = {
  userInfo: {
    districtName: null,
    districtId: null,
    firstName: null,
    lastName: null,
    userName: null,
    userGuid: null,
  },
  hash: '',
  accessInfo: [],
  preferences: [],
  accessInfoLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SECURITY_LOG_OUT:
      return INITIAL_STATE;
    case types.SECURITY_SET_ACCESS_INFO_LOADING:
      return {
        ...state,
        accessInfoLoading: action.payload,
      };

    case types.SECURITY_SET_USER_INFO:
      return {
        ...state,
        hash: action.payload.hash,
        userInfo: action.payload.userInfo,
      };
    case types.SECURITY_GET_ACCESS_INFO:
      return {
        ...state,
        accessInfo: action.payload,
        preferences: extractPreferencesFromAccessInfo(action.payload),
      };
    case types.SECURITY_CUSTOMIZE_NAVIGATION_MENU:
      return {
        ...state,
        accessInfo: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/Security/state/reducer.js